import { jwtDecode } from "jwt-decode";
import { BASE_URL } from "../../../config";

const tokenUrl = `${BASE_URL}/auth/realms/EK/protocol/openid-connect/token`;

export const setTokens = ({ access_token, refresh_token }) => {
    sessionStorage.setItem("accessToken", access_token);
    sessionStorage.setItem("refreshToken", refresh_token);
};

export const getAccessToken = () => sessionStorage.getItem("accessToken");
export const getRefreshToken = () => sessionStorage.getItem("refreshToken");

export const getUserInfo = () => {
    const token = getAccessToken();
    if (!token) return null;
    return jwtDecode(token);
};

export const getUserRoles = () => {
    const user = getUserInfo();
    return user?.realm_access?.roles || [];
};

export const isTokenExpired = (token) => {
    try {
        const decoded = jwtDecode(token);
        return decoded.exp * 1000 < Date.now();
    } catch {
        return true;
    }
};

export const refreshAccessToken = async () => {
    const refreshToken = getRefreshToken();
    if (!refreshToken) return null;

    const params = new URLSearchParams();
    params.append("grant_type", "refresh_token");
    params.append("client_id", "amg-client-mobile");
    params.append("refresh_token", refreshToken);

    const response = await fetch(tokenUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params,
    });

    if (!response.ok) return null;

    const result = await response.json();
    setTokens(result);
    return result.access_token;
};

export const clearTokens = () => {
    sessionStorage.removeItem("accessToken");
    sessionStorage.removeItem("refreshToken");
};
